import { Button, Css, Icon, Palette, useModal } from "@homebound/beam";
import { CreateGuidedChangeEventModal } from "src/routes/projects/change-events/components/CreateGuidedChangeEventModal";
import { useGuidedChangeEventActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useGuidedChangeEventActions";
import { SwapProductFormInput } from "src/routes/projects/change-events/guided/workflows/swapProductCatalog/swapProductWorkflow";
import { WorkflowFormState } from "src/routes/projects/change-events/guided/workflows/types";

type SwitchWorkflowButtonProps = { projectId: string; formState: WorkflowFormState<SwapProductFormInput> };

export function SwitchWorkflowButton(props: SwitchWorkflowButtonProps) {
  const { projectId, formState } = props;
  const { openModal } = useModal();
  const { saveChangeEvent } = useGuidedChangeEventActions({ form: formState, projectId });
  return (
    <div css={Css.df.aic.gap1.$}>
      <Button
        label="Switch Workflow"
        variant="secondary"
        onClick={async () => {
          await saveChangeEvent({ force: true });
          openModal({
            size: "xl",
            content: (
              <CreateGuidedChangeEventModal projectId={projectId} changeEventId={formState.id.value ?? undefined} />
            ),
          });
        }}
      />
      <Icon
        inc={2}
        icon="infoCircle"
        color={Palette.Gray600}
        tooltip="Clicking this will let you start over from a new Change Event workflow type, and save a draft of your current Change Event."
      />
    </div>
  );
}
